import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css'; // Միացնում ենք custom CSS-ը

const Header = () => {
    return (
        <header className="header">
            {/* Logo */}
            <Link to="/" onClick={() => window.location.reload()} className="flex items-center gap-3 group">
                <img
                    src="/I-Com_logo.png"
                    alt="I-com.LLC logo"
                    className="h-11 w-auto transition-transform duration-300 group-hover:scale-105"
                />

            </Link>

            {/* Navigation */}
            <nav className="nav-links">
                <a href="#home">Տուն</a>
                {/*<a href="#tariffs">Սակագներ</a>*/}
                <a href="#plans">Կապի Պլաններ</a>
                <a href="#contact">Կապ մեզ հետ</a>
            </nav>
        </header>
    );
};

export default Header;
